import { ArrowLeft, Plus, Wallet } from "lucide-react";
import Button from "@/components/ui/Button";
import { WALLET_RATES } from "@/pages/retailer/wallet/constants";
import { formatINR } from "@/pages/retailer/wallet/data";

interface Props {
  available: number;
  required?: number;
  onBack: () => void;
  onTopup: () => void;
}

export default function InsufficientBalance({
  available,
  required = WALLET_RATES.CREATION_CHARGE,
  onBack,
  onTopup,
}: Props) {
  const minRequired = required;
  const shortfall = Math.max(0, minRequired - available);

  return (
    <div className="w-full max-w-[520px] rounded-[10px] border border-line bg-card p-6 text-center shadow-card">
      <div className="mx-auto flex h-[72px] w-[72px] items-center justify-center rounded-full bg-danger-bg">
        <Wallet className="h-9 w-9 text-danger" />
      </div>
      <h2 className="mt-4 text-xl font-semibold text-ink">Insufficient wallet balance</h2>
      <p className="mt-1.5 text-sm text-ink-secondary">
        You need at least {formatINR(required)} to create a mandate. Your available balance is{" "}
        {formatINR(available)}.
      </p>

      <div className="mt-5 rounded-lg border border-line bg-page p-4 text-left">
        <div className="flex items-center justify-between py-1.5">
          <span className="text-[13px] text-ink-secondary">Available Balance</span>
          <span className="text-sm font-medium text-ink">{formatINR(available)}</span>
        </div>
        <div className="flex items-center justify-between py-1.5">
          <span className="text-[13px] text-ink-secondary">Required Balance</span>
          <span className="text-sm font-medium text-ink">{formatINR(required)}</span>
        </div>
        <div className="my-1.5 h-px bg-line" />
        <div className="flex items-center justify-between py-1.5">
          <span className="text-[13px] text-ink-secondary">Shortfall</span>
          <span className="text-sm font-semibold text-danger">{formatINR(shortfall)}</span>
        </div>
      </div>

      <div className="mt-5 flex justify-center gap-3">
        <Button variant="secondary" onClick={onBack} leftIcon={<ArrowLeft className="h-4 w-4" />}>
          Back to Mandates
        </Button>
        <Button onClick={onTopup} leftIcon={<Plus className="h-4 w-4" />}>
          Request Top-up
        </Button>
      </div>
    </div>
  );
}